import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import $, { get } from 'jquery';
import Modal from "react-modal";
import { withRouter } from '../utils/withRouter';

import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
// import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Home } from '@mui/icons-material';
import { useLocation } from "react-router-dom";

const AdminMobileDrawer = ({ head, userId }) => {
    const history = useNavigate();
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false)
    const [loginAccesslist, setLoginAccesslist] = useState([])

    //toggle model for logout.................................
    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const loadScripts = () => {
        // This array contains all the files/CDNs 
        // const dynamicScripts = [
        //   'js/jquery.sticky.js',
        //   'js/metisMenu.min.js',
        //   'js/metisMenu-active.js',
        //   'js/main.js'
        // ];

        // for (let i = 0; i < dynamicScripts.length; i++) {
        //   const node = document.createElement('script');
        //   node.src = dynamicScripts[i];
        //   node.type = 'text/javascript';
        //   node.async = false;
        //   document.getElementsByTagName('head')[0].appendChild(node);
        // }
    }
    const logout = () => {
        sessionStorage.clear()
        navigate('/')
    }
    useEffect(() => {
        loadScripts();
        const loginDataStr = sessionStorage.getItem('loginDataSS');
        if (loginDataStr) {
            try {
                const loginData = JSON.parse(loginDataStr);
                if (loginData && loginData['loginAccesslist']) {
                    setLoginAccesslist(loginData['loginAccesslist']);
                }
            } catch (e) {
                console.error("Error parsing loginDataSS", e);
            }
        }

    }, []);

    const location = useLocation();

    useEffect(() => {
        const allowedPaths = ["/hallMasterAU"];
        if (!allowedPaths.includes(location.pathname)) {
            sessionStorage.removeItem("ExhibitionHall")
            sessionStorage.removeItem("hallNameHall")
            sessionStorage.removeItem("ExhibitionOtherAreaIDHall")
        }
    }, [location.pathname]);

    const onRedirect = (path) => {
        history.push({ pathname: path, state: { 'isSearchClear': true } });
    }

    const [collapsed, setCollapsed] = useState(true);

    const handleToggleSidebar = () => {
        setCollapsed(!collapsed);
    }

    const getModuleAccess = (ModuleID) => {
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == ModuleID);
        if (moduleAccess) {
            return moduleAccess.ReadAccess;
        } else {
            return false
        }
        return false;
    };

    return (
        <>
            <style>
                {`
                .admin-mobile-sidemenu-override .side-menu__item {
                    padding-left: 15px !important;
                    border-top: none !important;
                    border-bottom: none !important;
                }
                .admin-mobile-sidemenu-override .slide {
                    border-top: none !important;
                }
                .admin-mobile-sidemenu-override .sub-menu .side-menu__item {
                    padding-left: 30px !important;
                    border-top: none !important;
                }
                .admin-mobile-sidemenu-override .sub-menu {
                    border-top: none !important;
                    border-bottom: none !important;
                }
                .admin-mobile-sidemenu-override .collapse {
                    border-top: none !important;
                    border-bottom: none !important;
                }
                `}
            </style>
            <Modal isOpen={isOpen} onRequestClose={e => toggleModal()}>
                <div className="modal-dialog custom_modal_dialog" >
                    <div className="modal-content confirm-logout
" style={{ borderRadius: '0px' }}>
                        <div class="modal-header">
                            <h5 class="modal-title modal_title_text">Confirm Logout</h5>
                            {/* <button type="button" class="close modal-close" data-dismiss="modal" onClick={this.toggleModal}>&times;</button> */}
                            <button type="button " class="close pop-close text-dark" data-dismiss="modal" onClick={e => toggleModal()} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>

                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3 class="pop_label">Do you really want to logout?</h3>
                                </div>
                            </div>
                        </div>

                        <div class="row ">
                            <div class="col-md-12">
                                <div class="form-group text-right mod-fot">
                                    <a class="btn save_btn del-pop-save" onClick={logout}> Yes</a>
                                    <a class="btn cancel_btn del-pop-cancel" data-dismiss="modal"
                                        style={{ marginLeft: '5px' }} onClick={toggleModal}> No</a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </Modal>
            <div className="sticky">
                <div className="app-sidebar__overlay" data-bs-toggle="sidebar" />
                <div className="" style={{ zIndex: 999 }}>
                    <div className="main-sidemenu admin-mobile-sidemenu-override">
                        <div className="slide-left disabled d-none" id="slide-left">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#7b8191"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                            >
                                <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
                            </svg>
                        </div>
                        <ul className="side-menu w-100 text-start text-left" style={{ marginRight: '0px', padding: '0', marginTop: '40px' }}>
                            {/* A - Agent Entry */}

                            {/* D - Dashboard */}
                            {getModuleAccess('1') &&
                                <li className="slide mobile-list">
                                    <Link to='/dashboard' >
                                        <a className="side-menu__item has-link" data-bs-toggle="slide">
                                            <span className="side-menu__label">
                                                 Dashboard
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {getModuleAccess('8') &&
                                <li className="slide mobile-list">
                                    <Link to='/agentlist' >
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Agent Entry
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }
                            {(getModuleAccess('2') || getModuleAccess('3') || getModuleAccess('4') || getModuleAccess('5') || getModuleAccess('6') ||
                                getModuleAccess('7')) &&
                                <li className="slide mobile-list" >
                                    <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                                        className="nav-link side-menu__item"
                                        data-bs-toggle="collapse"
                                        href="#accountsCollapse"
                                        aria-expanded="false"
                                        aria-controls="accountsCollapse"
                                    >
                                        <span className="side-menu__label">
                                            {" "}
                                             Accounts
                                         <i className="fa fa-angle-right float-end" style={{marginTop:"4px"}}></i> </span>
                                    </a>
                                    <div className="collapse " id="accountsCollapse">
                                        <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                                            {getModuleAccess('2') &&
                                                <li className="slide mobile-list">  <Link to='/agentReceiptList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Agent Receipt
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('7') &&
                                                <li className="slide mobile-list">  <Link to='/ddReturnList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             DD Return
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('7') &&
                                                <li className="slide mobile-list">  <Link to='/accountEntryPassList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Material Entry pass
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('7') &&
                                                <li className="slide mobile-list">  <Link to='/accountExitPassList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Material Exit pass
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('7') &&
                                                <li className="slide mobile-list">  <Link to='/taxinvoiceexhibitors'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Exhibitors
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('5') &&
                                                <li className="slide mobile-list">  <Link to='/ledgerList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Ledger
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('3') &&
                                                <li className="slide mobile-list">  <Link to='/proformalist'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Proforma Invoice list
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('2') &&
                                                <li className="slide mobile-list">  <Link to='/receiptlist'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Receipt
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('2') &&
                                                <li className="slide mobile-list">  <Link to='/refundList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Refund
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('4') &&
                                                <li className="slide mobile-list">  <Link to='/reminderEmails'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Reminder E-Mail
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('7') &&
                                                <li className="slide mobile-list">
                                                    <Link to={'/stallPossessionChecklistList'}>
                                                        <a className="side-menu__item">
                                                            <span className="side-menu__label">
                                                                 Stall Possession
                                                            </span>
                                                        </a>
                                                    </Link>
                                                </li>
                                            }
                                            {getModuleAccess('29') &&
                                                <li className="slide mobile-list">  <Link to='/accountTally'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Tally
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('6') &&
                                                <li className="slide mobile-list">  <Link to='/taxinvoicelist'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Tax Invoice List
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('2') &&
                                                <li className="slide mobile-list">  <Link to='/visitorReceiptList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Visitor Receipt
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('6') &&
                                                <li className="slide mobile-list">  <Link to='/visitorTaxInvoiceList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                             Visitor Tax Invoice List
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </li>
                            }

                            {/* C - Circulars */}
                            {getModuleAccess('14') &&
                                <li className="slide mobile-list">
                                    <Link to={'/addcircular'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Circulars
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* D - Daily Routine Checklist */}
                            {getModuleAccess('24') &&
                                <li className="slide mobile-list">
                                    <Link to={'/dailyRoutineChecklistList'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Daily Routine Checklist
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* E - Exhibitors */}
                            {getModuleAccess('9') &&
                                <li className="slide mobile-list">
                                    <Link to={'/exhibitorlist'} >
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Exhibitors
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }
                            {/* F - Features */}
                            {getModuleAccess('21') &&
                                <li className="slide mobile-list">
                                    <Link to={'/features'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Features
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* H - Hotel Enquiry */}
                            {getModuleAccess('35') &&
                                <li className="slide mobile-list">
                                    <Link to={'/hotelEnquiryList'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Hotel Enquiry
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* M - Manage Area */}
                            {getModuleAccess('20') &&
                                <li className="slide mobile-list">
                                    <Link to={'/manageArea'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Manage Area
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* M - Manual Forms Summary */}
                            {getModuleAccess('11') &&
                                <li className="slide mobile-list">
                                    <Link to={'/manualformsummary'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Manual Forms Summary
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {(getModuleAccess('12')) &&
                                <li className="slide mobile-list" >
                                    <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                                        className="nav-link side-menu__item"
                                        data-bs-toggle="collapse"
                                        href="#masters3"
                                        aria-expanded="false"
                                        aria-controls="masters3"
                                    >
                                        <span className="side-menu__label">
                                            {" "}
                                             Manual Forms
                                         <i className="fa fa-angle-right float-end" style={{marginTop:"4px"}}></i> </span>
                                    </a>
                                    <div className="collapse" id="masters3">
                                        <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                                            {getModuleAccess('12') &&
                                                <>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/airConnectionApplicationAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Air Connection Application
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/brandingOpportunityAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Branding Opportunity And Advertising Form
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/edirectoryAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     E-Directory Approval
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/exhibitorBadgesAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Exhibitor Badges Approval
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/meetingRoomRequestFormAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Meeting Room Request Form
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/powerConnectionAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Power Connection Approval
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/stallDesign_admin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Stall Design Approval
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/visainvitation'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     VA-Exhibitors
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/waterConnectionAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Water Connection
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                </>
                                            }
                                        </ul>
                                    </div>
                                </li>
                            }
                            {/* {getModuleAccess('13') &&
                <li className="slide mobile-list">
                  <Link to={'/visitorVisaInvitation'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                         VA-Visitors
                      </span>
                    </a>
                  </Link>
                </li>
              } */}
                            {/* M - Master */}
                            {getModuleAccess('27') &&
                                <li className="slide mobile-list" >
                                    <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                                        className="nav-link side-menu__item"
                                        data-bs-toggle="collapse"
                                        href="#masterCollapse"
                                        aria-expanded="false"
                                        aria-controls="masterCollapse"
                                    >
                                        <span className="side-menu__label">
                                             Master
                                         <i className="fa fa-angle-right float-end" style={{marginTop:"4px"}}></i> </span>
                                    </a>
                                    <div className="collapse " id="masterCollapse">
                                        <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                                            <li className="slide mobile-list">  <Link to='/attendeeTypeMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Attendee Type
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/bankDetailsList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Bank Details
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/chapterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Chapters
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/cityMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         City Master
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/ServiceDeliverableMaster'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Deliverable Services
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/exhibitionMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Exhibition
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/gstList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         GST
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/gateMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Gate
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/hallMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Hall
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/industrySegmentMaster'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Industry Segment
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/onlinePresenceList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Online Presence
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/purposeofVisitMaster'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Purpose of Visit
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/roleMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Role
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/stallMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Stall
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/stateMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         State Master
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/visitorTypeMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                         Visitor Type
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">
                                                <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                                                    className="nav-link side-menu__item"
                                                    data-bs-toggle="collapse"
                                                    href="#manualFormsMasterCollapse"
                                                    aria-expanded="false"
                                                    aria-controls="masterCollapse"
                                                >
                                                    <span className="side-menu__label">
                                                         Manual forms Master
                                                     <i className="fa fa-angle-right float-end" style={{marginTop:"4px"}}></i> </span>
                                                </a>
                                                <div className="collapse " id="manualFormsMasterCollapse">
                                                    <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                                                        <li className="slide mobile-list">  <Link to='/additionalFurnitureMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Additional Furniture
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/brandingOpportunityMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Branding Opportunity
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/cateringServicesMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Catering Services
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/delegateMeetingMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Delegate Meeting
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/hostAndHostessMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Host and Hostess
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/housekeepingApplicationMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Housekeeping Application
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/internetConnectionMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Internet Connection
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/leadRetrivalConnectionMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Lead Retrival connection
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/liquorlicenseMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Liquor License
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/meetingRoomMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Meeting Room
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/prAgencyMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     PR Agency
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/photographyAndVideographyMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Photography And Videography
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/rentalAudioVideoMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Rental Audio & Video
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/securityApplicationMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Security Application
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/visitorMeetingMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Visitor Meeting
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            }

                            {/* O - Organizer Tracker */}
                            {getModuleAccess('24') &&
                                <li className="slide mobile-list">
                                    <Link to='/organizerTrackerList'>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Organizer Tracker
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* O - Organizer Routine Tasklist */}
                            {getModuleAccess('24') &&
                                <li className="slide mobile-list">
                                    <Link to={'/dailyRoutineTaskList'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Organizer Routine Tasklist
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }
                            {/* {
                getModuleAccess('36') &&
                <li className="slide mobile-list">
                  <Link to={'/addDelegateCircular'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                         Delegate Circulars
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {getModuleAccess('35') &&
                <li className="slide mobile-list" >
                  <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                    className="nav-link side-menu__item"
                    data-bs-toggle="collapse"
                    href="#DelegateMasterCollapse"
                    aria-expanded="false"
                    aria-controls="DelegateMasterCollapse"
                  >
                    <span className="side-menu__label">
                      {" "}
                       Delegate Master
                     <i className="fa fa-angle-right float-end" style={{marginTop:"4px"}}></i> </span>
                  </a>
                  <div className="collapse " id="DelegateMasterCollapse">
                    <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                      <li className="slide mobile-list">
                        <Link to='/delegateInvitationType'>
                          <a className="side-menu__item"
                          >
                            <span className="side-menu__label">
                              {" "}
                               Invitation Type
                            </span>
                          </a></Link>
                      </li>
                      <li className="slide mobile-list">
                        <Link to='/delegateInvitationEventList'>
                          <a className="side-menu__item"
                          >
                            <span className="side-menu__label">
                              {" "}
                               Invitation Event
                            </span>
                          </a></Link>
                      </li>
                    </ul>
                  </div>
                </li>
              } */}
                            {/* R - Reports */}
                            {getModuleAccess('15') &&
                                <li className="slide mobile-list">
                                    <Link to={'/reportList'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Reports
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* U - Users */}
                            {getModuleAccess('28') &&
                                <li className="slide mobile-list">
                                    <Link to={'/userList'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Users
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* V - VA-Visitors */}
                            {getModuleAccess('13') &&
                                <li className="slide mobile-list">
                                    <Link to={'/visitorVisaInvitation'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 VA-Visitors
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* V - Visitors */}
                            {getModuleAccess('10') &&
                                <li className="slide mobile-list">
                                    <Link to={'/visitorslist'} >
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Visitors
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* S - Service Partner */}
                            {(getModuleAccess('23')) &&
                                <li className="slide mobile-list" >
                                    <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                                        className="nav-link side-menu__item"
                                        data-bs-toggle="collapse"
                                        href="#masters2"
                                        aria-expanded="false"
                                        aria-controls="masters2"
                                    >
                                        <span className="side-menu__label">
                                             Service Partner
                                         <i className="fa fa-angle-right float-end" style={{marginTop:"4px"}}></i> </span>
                                    </a>
                                    <div className="collapse " id="masters2">
                                        <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                                            {getModuleAccess('23') &&
                                                <>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/VendorPlan'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Plan and Timeline
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/vendorWorkOrderList'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Scope of work
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/VendorRegistrationList'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                     Service Partner Registration
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                </>
                                            }
                                        </ul>
                                    </div>
                                </li>
                            }

                            {/* V - Visitors Circulars */}
                            {getModuleAccess('24') &&
                                <li className="slide mobile-list">
                                    <Link to={'/addVisitorCircular'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                 Visitors Circulars
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }
                            {/* {getModuleAccess('16') &&
                <li className="slide mobile-list">
                  <Link to={'/fasciaadmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                         Fascia Approval
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {getModuleAccess('17') &&
                <li className="slide mobile-list">
                  <Link to={'/exhibitorBadgesAdmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                         Exhibitor Badges Approval
                      </span>
                    </a>
                  </Link>
                </li>
              } */}

                            {/* {getModuleAccess('18') &&
                <li className="slide mobile-list">
                  <Link to={'/edirectoryAdmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                         E-Directory Approval
                      </span>
                    </a>
                  </Link>
                </li>
              } */}

                            {/* <li className="slide mobile-list">
                <Link to={'/powerreqadmin'}>
                  <a className="side-menu__item"
                  >
                    <span className="side-menu__label">
                      {" "}
                       Power Connection Approval
                    </span>
                  </a>
                </Link>
              </li> */}

                            {/* <li className="slide mobile-list" style={{cursor:'pointer'}}   data-toggle="modal" data-target="#logout" onClick={toggleModal}>
                  <a className="side-menu__item"
                   >
                    <span className="side-menu__label">
                      {" "}
                       Log Out

                      
                    </span>
                  </a>
              </li> */}

                            {/*  <li class="slide mobile-list">
                          <a class="side-menu__item has-link" data-bs-toggle="slide mobile-list" href="#"><i class="side-menu__icon fe fe-activity "></i><span class="side-menu__label">Survey</span></a>
                      </li> */}
                        </ul>
                        <div className="slide-right" id="slide-right">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#7b8191"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                            >
                                <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />
                            </svg>
                        </div>
                    </div>

                    <div className="ps__rail-x" style={{ left: '0', bottom: '0' }}>
                        <div className="ps__thumb-x" tabIndex={0} style={{ left: '0', width: '0' }} />
                    </div>
                    <div className="ps__rail-y" style={{ top: '0', right: '0', height: '625px' }}>
                        <div
                            className="ps__thumb-y"
                            tabIndex={0}
                            style={{ top: '0', height: '554px' }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
export default AdminMobileDrawer;